/**
 * Devuelve el múltiplo superior más cercano a un número
 * @param num Número referencia
 * @param factor Factor del múltiplo
 */
export const getNextMultiple = (num: number, factor: number) => {
  const mul = factor !== 0 ? Math.ceil(num / factor) : 0;
  return factor * mul;
};

/**
 * Devuelve el múltiplo inferior más cercano a un número
 * @param num Número referencia
 * @param factor Factor del múltiplo
 */
export const getPrevMultiple = (num: number, factor: number) => {
  const mul = factor !== 0 ? Math.floor(num / factor) : 0;
  return factor * mul;
};
